import Button from '@berlitz/button'
import styled, { css } from 'styled-components'

export const RefreshTime = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  text-align: right;
  margin-top: ${({ theme }) => theme.space.xxs};
`
export const Wrapper = styled.div<{ alignRight?: boolean }>`
  display: flex;
  padding-left: ${({ theme }) => theme.space.xs};
  ${({ alignRight }) =>
    alignRight &&
    css`
      margin-left: auto;
    `};
`

export const RefreshButton = styled(Button)`
  border-color: ${({ theme }) => theme.colors.brandPrimary};
  margin-left: ${({ theme }) => theme.space.xs};
`
